export interface Category {
  slug: string;
  name: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'recommend', name: '推荐', description: '编辑精选韩漫推荐' },
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', description: '脑洞大开的奇幻冒险' },
  { slug: 'action', name: '动作', description: '热血沸腾的动作韩漫' },
  { slug: 'bl', name: '耽美', description: '人气耽美韩漫作品' },
  { slug: 'drama', name: '剧情', description: '扣人心弦的剧情佳作' },
  { slug: 'thriller', name: '悬疑', description: '烧脑刺激的悬疑韩漫' },
  { slug: 'comedy', name: '搞笑', description: '轻松欢乐的搞笑韩漫' },
  { slug: 'slice-of-life', name: '日常', description: '温馨治愈的日常韩漫' },
  { slug: 'completed', name: '完结', description: '已完结的经典韩漫' },
];